var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 874,
    viewBox: "0 0 1440 874",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 874,
    fill: "#DEF2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_1714_4502)",
    filter: "url(#filter0_b_1714_4502)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1714_4502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M742.304 824.309C371.002 768.17 92.7254 847.7 0 894.483V1000H1440V841.724C1362.14 859.31 1113.61 880.448 742.304 824.309Z",
    fill: "#0071BC",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.696 815.612C1069 759.569 993.57 877.196 1440 815.612V991L0 991V832.997C77.8558 850.553 208.434 889.458 697.696 815.612Z",
    fill: "#007ED1",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1714_4502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M742.304 851.346C294.614 921.505 92.7254 874.732 0 921.505V1027H1440V868.757C1362.14 886.34 1113.3 793.206 742.304 851.346Z",
    fill: "#68C1FC",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.696 847.346C1145.39 917.505 1347.27 870.732 1440 917.505V1023L0 1023V864.757C77.8558 882.34 326.704 789.206 697.696 847.346Z",
    fill: "#F5F5F5",
    fillOpacity: 0.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1714_4502",
    x: -16,
    y: 779,
    width: 1472,
    height: 111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1714_4502"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1714_4502",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1714_4502",
    x: -40,
    y: 760,
    width: 1520,
    height: 280,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1714_4502"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1714_4502",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1714_4502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 79,
    fill: "white",
    transform: "translate(0 795)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1714_4502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 159,
    fill: "white",
    transform: "translate(0 821)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateBackground);
export default __webpack_public_path__ + "static/media/private-background.9be39de9ba364e872cc425f01f6f6ef3.svg";
export { ForwardRef as ReactComponent };